import {React, StrictMode } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import 'material-icons/iconfont/material-icons.css';

ReactDOM.render(
    <StrictMode>
      <App />
    </StrictMode>,
  document.getElementById("root")
);
